import * as React from 'react';
import { Omit } from '../../../utilities/Omit';
import { IActionProps } from '../../action/Action';
import { WithItemCache, IItemCacheStateProps } from '../../withItemCache/WithItemCache';
import { progressRootItemKey, getOverallProgressPhase, progressAddon } from '../../../operations/progress';
import { WizardAction, IWizardActionStateProps } from '../../wizardAction/WizardAction';
import { childItemsFacet } from '../../../facets/SetFacets';
import { ProgressPhase } from '../../../facets/ProgressFacets';
import { asAsync } from '../../../utilities/components/Async';
import { afterPageLoad } from '../../decorators/afterPageLoad';
import { createItemCacheInitializer } from '../../itemCacheInitializer/ItemCacheInitializer';

export type IShowProgressActionProps = Omit<IActionProps, 'isAvailable' | 'onExecute' | 'isToggled'>;

const ProgressPanel = afterPageLoad()(asAsync(async () => (
    await import(/* webpackChunkName: 'deferredcomponents' */'../../DeferredComponents')
).ProgressPanel));

const ProgressInitializer = createItemCacheInitializer(() => progressAddon);

/**
 * Action to show Progress for operations performed in the item cache.
 */
export class ShowProgressAction extends React.PureComponent<IShowProgressActionProps> {
    public render(): JSX.Element {
        return (
            <ProgressInitializer>
                <WithItemCache>
                    {
                        ({ itemCache }: IItemCacheStateProps): JSX.Element => {
                            const progressChildItems = itemCache.demandItemFacet(childItemsFacet, progressRootItemKey);

                            let isAvailable = false;

                            const progressItemKeys = progressChildItems && progressChildItems.itemKeys;

                            if (progressItemKeys) {
                                for (const progressItemKey of progressItemKeys) {
                                    const progressPhase = getOverallProgressPhase(itemCache, { itemKey: progressItemKey });

                                    if (progressPhase !== ProgressPhase.expired) {
                                        isAvailable = true;
                                        break;
                                    }
                                }
                            }

                            return (
                                <WizardAction
                                    isAvailable={ isAvailable }
                                >
                                    { (wizardProps: IWizardActionStateProps) => {
                                        return (
                                            <ProgressPanel { ...wizardProps } />
                                        );
                                    } }
                                </WizardAction>
                            );
                        }
                    }
                </WithItemCache>
            </ProgressInitializer>
        );
    }
}
